var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    viewBox: "0 0 66 65",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.38 65H5.175C2.322 65 0 62.698 0 59.868V5.132C0 2.302 2.322 0 5.175 0H60.38c2.854 0 5.176 2.302 5.176 5.132v54.736c0 2.83-2.322 5.132-5.176 5.132zM5.175 3.421a1.72 1.72 0 00-1.725 1.71v54.737c0 .944.774 1.71 1.725 1.71H60.38a1.72 1.72 0 001.725-1.71V5.132a1.72 1.72 0 00-1.725-1.71H5.175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.95 31.06H34.494V15.607a1.717 1.717 0 00-3.434 0v15.455H15.606a1.717 1.717 0 000 3.434h15.455v15.454a1.717 1.717 0 003.434 0V34.495h15.454a1.717 1.717 0 100-3.434z"
  }))));
}

export default SvgPlusSquare;